import { render, staticRenderFns } from "./Premios.vue?vue&type=template&id=69da807f&"
import script from "./Premios.vue?vue&type=script&lang=js&"
export * from "./Premios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports